import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const AgregarListaAlarmaService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Alarma/AgregarAlarmaListaDistribucion",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { AgregarListaAlarmaService };